// extracted by mini-css-extract-plugin
export default {"onboardingDialog":"f6e9wXYcBNmgYNuGB6JW"};